export const OPEN_CRYPTA_SOCIAL_DEMO_EDITOR = 'OPEN_CRYPTA_SOCIAL_DEMO_EDITOR';
export type OPEN_CRYPTA_SOCIAL_DEMO_EDITOR = typeof OPEN_CRYPTA_SOCIAL_DEMO_EDITOR;

export interface OpenCryptaSocialDemoEditor {
    type: OPEN_CRYPTA_SOCIAL_DEMO_EDITOR;
    id: string;
    itemsId: string[];
}

export function openCryptaSocialDemoEditor(
    id: string,
    itemsId: string[]
): OpenCryptaSocialDemoEditor {
    return {
        type: OPEN_CRYPTA_SOCIAL_DEMO_EDITOR,
        id,
        itemsId
    };
}

export const CLOSE_CRYPTA_SOCIAL_DEMO_EDITOR =
    'CLOSE_CRYPTA_SOCIAL_DEMO_EDITOR';
export type CLOSE_CRYPTA_SOCIAL_DEMO_EDITOR = typeof CLOSE_CRYPTA_SOCIAL_DEMO_EDITOR;

export interface CloseCryptaSocialDemoEditor {
    type: CLOSE_CRYPTA_SOCIAL_DEMO_EDITOR;
    id: string;
    itemsId?: string[];
}

export function closeCryptaSocialDemoEditor(
    id: string,
    itemsId?: string[]
): CloseCryptaSocialDemoEditor {
    return {
        type: CLOSE_CRYPTA_SOCIAL_DEMO_EDITOR,
        id,
        itemsId
    };
}

export const CHANGE_ITEM_CRYPTA_SOCIAL_DEMO = 'CHANGE_ITEM_CRYPTA_SOCIAL_DEMO';
export type CHANGE_ITEM_CRYPTA_SOCIAL_DEMO = typeof CHANGE_ITEM_CRYPTA_SOCIAL_DEMO;

export interface ChangeItemCryptaSocialDemo {
    type: CHANGE_ITEM_CRYPTA_SOCIAL_DEMO;
    id: string;
    itemId: string;
}

export function changeItemCryptaSocialDemo(
    id: string,
    itemId: string
): ChangeItemCryptaSocialDemo {
    return {
        type: CHANGE_ITEM_CRYPTA_SOCIAL_DEMO,
        id,
        itemId
    };
}

export const SAVE_CRYPTA_SOCIAL_DEMO = 'SAVE_CRYPTA_SOCIAL_DEMO';
export type SAVE_CRYPTA_SOCIAL_DEMO = typeof SAVE_CRYPTA_SOCIAL_DEMO;

export interface SaveCryptaSocialDemo {
    type: SAVE_CRYPTA_SOCIAL_DEMO;
    id: string;
}

export function saveCryptaSocialDemo(id: string): SaveCryptaSocialDemo {
    return {
        type: SAVE_CRYPTA_SOCIAL_DEMO,
        id
    };
}

export type CryptaSocialDemoEditorAction =
    | CloseCryptaSocialDemoEditor
    | OpenCryptaSocialDemoEditor
    | ChangeItemCryptaSocialDemo
    | SaveCryptaSocialDemo;
